import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminService } from '../../services/adminService';
import './Admin.css';

const AdminUsers = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('');
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchUsers = () => {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (statusFilter) params.set('status', statusFilter);
    params.set('page', page);
    adminService.getUsers(params.toString())
      .then(res => {
        setUsers(res.data.data);
        setLastPage(res.data.last_page);
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => { fetchUsers(); }, [page, statusFilter]);

  const handleSearch = (e) => {
    e.preventDefault();
    setPage(1);
    fetchUsers();
  };

  const handleStatusChange = async (userId, newStatus) => {
    if (!window.confirm(`Change user status to ${newStatus}?`)) return;
    try {
      await adminService.updateUserStatus(userId, newStatus);
      fetchUsers();
    } catch (err) {
      alert(err.response?.data?.message || 'Failed to update status');
    }
  };

  return (
    <div className="admin-page">
      <h1>Users</h1>
      <div className="admin-table-wrapper">
        <div className="admin-toolbar">
          <form onSubmit={handleSearch} style={{ display: 'flex', gap: '8px', flex: 1 }}>
            <input placeholder="Search by name, email, phone..." value={search} onChange={e => setSearch(e.target.value)} />
            <button type="submit" className="admin-action-btn edit">Search</button>
          </form>
          <select value={statusFilter} onChange={e => { setStatusFilter(e.target.value); setPage(1); }}>
            <option value="">All Status</option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
            <option value="suspended">Suspended</option>
            <option value="deleted">Deleted</option>
          </select>
        </div>
        {loading ? <div style={{ padding: 20 }}>Loading...</div> : (
          <>
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Profile ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Status</th>
                  <th>Registered</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {users.map(u => (
                  <tr key={u.id}>
                    <td>{u.profile?.profile_id || '-'}</td>
                    <td>{u.profile ? `${u.profile.first_name} ${u.profile.last_name || ''}` : '-'}</td>
                    <td>{u.email}</td>
                    <td>{u.phone}</td>
                    <td><span className={`status-badge ${u.status}`}>{u.status}</span></td>
                    <td>{new Date(u.created_at).toLocaleDateString('en-IN')}</td>
                    <td>
                      <button className="admin-action-btn edit" onClick={() => navigate(`/admin/users/${u.id}/edit`)}>Edit</button>
                      {u.status !== 'active' && <button className="admin-action-btn activate" onClick={() => handleStatusChange(u.id, 'active')}>Activate</button>}
                      {u.status !== 'suspended' && <button className="admin-action-btn suspend" onClick={() => handleStatusChange(u.id, 'suspended')}>Suspend</button>}
                      {u.status !== 'deleted' && <button className="admin-action-btn delete" onClick={() => handleStatusChange(u.id, 'deleted')}>Delete</button>}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <div className="admin-pagination">
              <button disabled={page <= 1} onClick={() => setPage(page - 1)}>← Prev</button>
              <span style={{ padding: '6px 12px', fontSize: '0.85rem' }}>Page {page} of {lastPage}</span>
              <button disabled={page >= lastPage} onClick={() => setPage(page + 1)}>Next →</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default AdminUsers;
